module.exports = __webpack_public_path__ + "static/media/sms-template-icon.7a18d22c.svg";